(function() {
    'use strict';

    angular
        .module('app')
        .controller('editPwdModalController', editPwdModalController);

    function editPwdModalController(loginService, sysCode, e2eService,
        $rootScope, $uibModalInstance, $route, $scope) {
        var vm = this;
        vm.submit = submit;
        vm.autoFill = autoFill;
        vm.cancel = cancel;

        // virtual keyboard start
        vm.showVirKey = showVirKey;
        vm.isShowVirKey = false;
        vm.textChanged = textChanged;
        vm.focusObj = null
        vm.virData = null;

        // 針對哪個 input 使用動態鍵盤輸入
        vm.getFocusOldPwd = function () {
            vm.focusObj = "oldPwd";
            vm.virData = vm.data.oldPwd;
        }
        vm.getFocusNewPwd = function () {
            vm.focusObj = "newPwd";
            vm.virData = vm.data.newPwd;
        }
        vm.getFocusConfirmPwd = function () {
            vm.focusObj = "confirmPwd";
            vm.virData = vm.data.confirmPwd;
        }


        function textChanged(newPwd) {
            console.log("vm.focusObj:",vm.focusObj);
            var e = document.getElementById(vm.focusObj);
            e.value = newPwd;
            console.log("newPwd:",newPwd);
            var $e = angular.element(e);
            $e.triggerHandler('input');
        }

        function showVirKey() {
            if (vm.isShowVirKey)
                vm.isShowVirKey = false;
            else
                vm.isShowVirKey = true;
        }

        init();

        function init() {
            vm.data = {};
            loginService.getSsoInfo().then(function(data) {
                vm.data.userAccount = data.data.userAccount;
            });
        }

        function submit() {
            vm.confirmPwd = vm.data.newPwd == vm.data.oldPwd;
            if (!vm.confirmPwd){
                vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
            }
            
            if (!vm.confirmPwd) {
                loginService.setSsoParams(vm.data);
                loginService.modifyUserPassword(vm.data).then(function(data) {
					if(data !== undefined){
						removeSsoInfo();
						$route.reload();
						toastr.success($rootScope.translate.commonEditPwdSuccess);
						$uibModalInstance.close();
					}
                    
                });
            }
        }

        function autoFill() {
            e2eService.editPwdModal(vm.data);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();